import type { ChatAccessMode } from './chatAccessMode';

interface ChatAccessModeSelectProps {
  mode: ChatAccessMode;
  onChange: (mode: ChatAccessMode) => void;
  disabled: boolean;
}

export function ChatAccessModeSelect({ mode, onChange, disabled }: ChatAccessModeSelectProps) {
  return (
    <label className="inline-flex shrink-0 items-center gap-1 font-mono text-[10px] uppercase tracking-wider text-ink-3">
      <span>Access</span>
      <select
        aria-label="Chat access mode"
        value={mode}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value === 'full_access' ? 'full_access' : 'ask')}
        className="rounded-md border border-warm-border bg-paper px-1.5 py-1 text-[11px] font-semibold text-ink-2 focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-coral/15 disabled:opacity-60"
      >
        <option value="ask">Ask</option>
        <option value="full_access">Full access</option>
      </select>
    </label>
  );
}
